import { injectable } from 'inversify';
import { FilterKey } from '@studyportals/search-filters';
import type {
	ISeoFilterState,
	ISeoInfoBase
} from '@studyportals/fawkes/organisations-search-seo';

@injectable()
export class SeoIndexabilityInfoBase implements ISeoInfoBase {

	public async selectionOnlyFor(keys: FilterKey[], filterSelectionState: ISeoFilterState): Promise<boolean> {
		const selected = filterSelectionState.getSelectedFilters();

		const allKeysIncluded = keys.every((key) => selected.includes(key));

		return Promise.resolve(selected.length === keys.length && allKeysIncluded);
	}

	public singleSelectionFor(filterKey: FilterKey, filterSelectionState: ISeoFilterState): Promise<boolean> {
		return Promise.resolve(filterSelectionState.getSelectedValuesFor(filterKey).length === 1);
	}

	public getSelectionTypeCount(filterSelectionState: ISeoFilterState): number {
		return filterSelectionState.getSelectedFilters().length;
	}

	public getFilterOptionValueBy(filterKey: FilterKey, filterSelectionState: ISeoFilterState): string | null {
		const filterSelection = filterSelectionState.getSelectedValuesFor(filterKey);
		if (filterSelection.length === 0) {
			return null;
		}

		return filterSelection[0];
	}
}
